import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StoreConsumptionDetails } from '.';

export class StoreConsumptionResponse extends GlobalResponseObject {
    data?: StoreConsumptionDetails;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: StoreConsumptionDetails){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}